module.exports = __webpack_public_path__ + "img/cvp1@2x.ab73190c.png";